import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { removeDuplicateStories } from '../../utils';
export var LoadMoreStoriesManager = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadMoreStoriesManager, _React$Component);

  var _super = /*#__PURE__*/_createSuper(LoadMoreStoriesManager);

  function LoadMoreStoriesManager(props) {
    var _this;

    _classCallCheck(this, LoadMoreStoriesManager);

    _this = _super.call(this, props);
    _this.state = {
      loading: false,
      pageNumber: 1,
      moreStories: [],
      noMoreStories: false
    };
    return _this;
  }

  _createClass(LoadMoreStoriesManager, [{
    key: "stories",
    value: function stories() {
      return this.props.stories.concat(this.state.moreStories);
    }
  }, {
    key: "loadMore",
    value: function loadMore(e) {
      var _this2 = this;

      e.preventDefault();
      if (this.state.loading) return;
      var pageNumber = this.state.pageNumber;
      this.setState({
        loading: true,
        pageNumber: pageNumber + 1
      }, function () {
        _this2.props.loadStories(pageNumber).then(function (stories) {
          _this2.setState({
            loading: false,
            moreStories: _this2.state.moreStories.concat(removeDuplicateStories(_this2.stories(), stories)),
            noMoreStories: stories.length < _this2.props.numStoriesToLoad
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return this.props.template(Object.assign({}, this.props, {
        stories: this.stories(),
        onLoadMore: function onLoadMore(e) {
          return _this3.loadMore(e);
        },
        loading: this.state.loading,
        noMoreStories: this.state.noMoreStories
      }));
    }
  }]);

  return LoadMoreStoriesManager;
}(React.Component);